import { Plan } from './';

export class Customer {

  public balance: number;
  public created: Date;
  public currency: string;
  public defaultSource: string;
  public delinquent: boolean;
  public description: string;
  public discount: string;
  public email: string;
  public id: string;
  public invoicePrefix: string;
  public livemode: boolean;
  public metadata: any;

  public sources: Array<Source>;
  public subscriptions: Array<Subscription>;

  constructor(json: any) {
    // data from stripe
    try {
      this.setStripeData(json);
    } catch (ex) {
      this.setDefaults();
    }
  }

  private setStripeData(json: any) {
    this.id = json.id || '';

    this.balance = json.account_balance || 0;
    this.created = new Date(json.created);
    this.currency = json.currency;
    this.defaultSource = json.default_source || '';

    this.delinquent = json.delinquent || false;
    this.description = json.description || '';
    this.discount = ''; // json.discount
    this.email = json.email || '';

    this.invoicePrefix = json.invoice_prefix || '';
    this.livemode = json.livemode;
    this.metadata = json.metadata;

    this.setSources(json.sources.data);

    this.setSubscriptions(json.subscriptions.data);
  }

  private setSources(sources: Array<any>) {
    this.sources = [];
    try {
      for (let current = 0; current < sources.length; current++) {
        this.sources.push(new Source(sources[current]));
      }
    } catch (ex) {
    }
  }

  private setSubscriptions(subscriptions: Array<any>) {
    this.subscriptions = [];
    try {
      for (let current = 0; current < subscriptions.length; current++) {
        this.subscriptions.push(new Subscription(subscriptions[current]));
      }
    } catch (ex) {
    }
  }

  private setDefaults() {
    this.id = '';
    this.balance = 0;
    this.created = null;
    this.currency = '';
    this.defaultSource = '';
    this.delinquent = false;
    this.description = '';
    this.email = '';
    this.invoicePrefix = '';
    this.livemode = false;
    this.metadata = {};

    this.sources = [];
    this.subscriptions = [];
  }
}

export class Source {
  // just cards at the moment

  addressCity: string;
  addressCountry: string;
  addressLineOne: string;
  addressLineTwo: string;
  addressZip: string;

  brand: string;
  country: string;
  customer: string;
  cvcCheck: string;
  expMonth: '';
  expYear: '';

  funding: string;
  id: string;
  lastFour: string;

  metadata: any;

  name: string;

  constructor(json: any) {
    try {
      this.setStripeData(json);
    } catch (ex) {
      this.setDefaults();
    }
  }

  private setStripeData(json: any) {
    this.addressCity = json.address_city || '';
    this.addressCountry = json.address_country || '';
    this.addressLineOne = json.address_line1 || '';
    this.addressLineTwo = json.address_line2 || '';
    this.addressZip = json.address_zip || '';

    this.brand = json.brand || '';
    this.country = json.country || '';
    this.customer = json.customer || '';
    this.cvcCheck = json.cvc_check || '';
    this.expMonth = json.exp_month || '';
    this.expYear = json.exp_year || '';

    this.funding = json.funding || '';
    this.id = json.id || '';
    this.lastFour = json.last4 || '';

    this.metadata = json.metadata || {};

    this.name = json.name || '';
  }

  private setDefaults() {
    this.addressCity = '';
    this.addressCountry = '';
    this.addressLineOne = '';
    this.addressLineTwo = '';
    this.addressZip = '';

    this.brand = '';
    this.country = '';
    this.customer = '';
    this.cvcCheck = '';
    this.expMonth = '';
    this.expYear = '';

    this.funding = '';
    this.id = '';
    this.lastFour = '';

    this.metadata = {};

    this.name = '';
  }
}

export class Subscription {
  billing: string;
  cancelAtPeriodEnd: false;
  canceledAt: Date;
  created: Date;
  currentPeriodEnd: Date;
  currentPeriodStart: Date;

  customer: string;
  discount: string;
  id: string;

  items: any;
  livemode: boolean;
  metadata: any;
  plan: Plan;

  start: Date;
  status: string;
  trialEnd: Date;
  trialStart: Date;

  constructor(json: any) {
    try {
      this.setStripeData(json);
    } catch (ex) {
      this.setDefaults();
    }
  }

  private setStripeData(json: any) {
    this.billing = json.billing || '';
    this.cancelAtPeriodEnd = json.cancel_at_period_end || false;
    this.canceledAt = json.canceled_at || null;
    this.created = json.created || null;
    this.currentPeriodEnd = json.current_period_end || null;
    this.currentPeriodStart = json.current_period_start || null;

    this.customer = json.customer || '';
    this.discount = json.discount || '';
    this.id = json.id || '';

    this.items = json.items || {};
    this.livemode = json.livemode || false;
    this.metadata = json.metadata || {};
    this.plan = new Plan(json.plan);

    this.start = json.start || null;
    this.status = json.status || '';
    this.trialEnd = json.trial_end || null;
    this.trialStart = json.trial_start || null;
  }

  private setDefaults() {
    this.billing = '';
    this.cancelAtPeriodEnd = false;
    this.canceledAt = null;
    this.created = null;
    this.currentPeriodEnd = null;
    this.currentPeriodStart = null;

    this.customer = '';
    this.discount = '';
    this.id = '';

    this.items = {};
    this.livemode = false;
    this.metadata = {};
    this.plan = new Plan(null);

    this.start = null;
    this.status = '';
    this.trialEnd = null;
    this.trialStart = null;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/customer.ts